import React, {useEffect, useRef, useState} from 'react';
import {Modal} from 'antd';
import {Announcement} from '../../types/announcement';

interface AnnouncementModalProps {
    visible: boolean;
    announcement: Announcement | null;
    onClose: () => void;
}

const AnnouncementModal: React.FC<AnnouncementModalProps> = ({
                                                                 visible,
                                                                 announcement,
                                                                 onClose
                                                             }) => {
    const [countdown, setCountdown] = useState(10);

    // 使用 ref 保存 onClose 的引用，避免 useEffect 频繁重新执行
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    // 跳转公告倒计时逻辑
    useEffect(() => {
        if (!visible || !announcement || announcement.type !== 'jump') {
            return;
        }

        setCountdown(10);

        const timer = setInterval(() => {
            setCountdown(c => {
                if (c <= 1) {
                    clearInterval(timer);
                    // 倒计时结束，跳转链接
                    if (announcement.jumpUrl) {
                        window.open(announcement.jumpUrl, '_blank');
                    }
                    onCloseRef.current();
                    return 0;
                }
                return c - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [visible, announcement]);

    // 用户关闭弹窗，清除倒计时
    const handleCancel = () => {
        setCountdown(10);
        onClose();
    };

    if (!announcement) {
        return null;
    }

    // 平台公告内容展示
    if (announcement.type === 'platform') {
        return (
            <Modal
                title={announcement.title}
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width={600}
                centered
            >
                <div style={{padding: '16px 0', lineHeight: 1.8}}>
                    {announcement.content}
                </div>
            </Modal>
        );
    }

    // 跳转公告内容展示
    return (
        <Modal
            title={
                <div style={{textAlign: 'center', width: '100%'}}>
                    {announcement.title}
                </div>
            }
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={500}
            centered
        >
            <div style={{padding: '24px 0', textAlign: 'center'}}>
                {/* 链接地址在左，图标在右 */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                    gap: '12px'
                }}>
                    <span style={{fontSize: '32px', flexShrink: 0}}>🔗</span>
                    <span style={{fontSize: '14px', color: 'rgba(255,255,255,0.65)', wordBreak: 'break-all'}}>
                        {announcement.jumpUrl}
                    </span>
                </div>
                {/* 倒计时 - 大号黄色字体 */}
                <div style={{
                    fontSize: '48px',
                    fontWeight: 'bold',
                    color: countdown > 0 ? '#F0B429' : 'var(--pt-bull)'
                }}>
                    {countdown > 0 ? countdown : '跳转中...'}
                </div>
                {/* 提示文字 */}
                {countdown > 0 && (
                    <div style={{fontSize: '12px', color: 'rgba(255,255,255,0.45)', marginTop: '8px'}}>
                        页面将在 {countdown} 秒后自动跳转
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default AnnouncementModal;
